
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/forex/forex-cards",
      function () {
        return require("private-next-pages/help/forex/forex-cards.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/forex/forex-cards"])
      });
    }
  